import React from 'react';
// Constants
import {
  CompanyName,
  CompanyPhoneNumber,
  CompanyTagLine,
} from '../../utils/Constants';
// Images
import MainLogoImage from '../../assets/images/logos/ascari-building-contractors-orange-logo-letter-black.png';

function HomePageHeader() {
  return (
    <header className='grid h-full w-full'>
      <div className='grid'>
        {/* Section one */}
        <section className='relative grid min-h-[70vh] lg:min-h-screen bg-colour1 general_header_shape justify-center h-full w-full'>
          <div className='z-30 absolute max-h-[68vh] lg:max-h-[98vh] grid items-center general_header_shape justify-center h-full w-full bg-center bg-hero bg-no-repeat bg-cover'>
            <div className='absolute inset-0 bg-black/30'></div>
          </div>
          <div className='z-20 absolute min-h-[65vh] grid bg-colour5 general_header_shape justify-center h-full w-full'></div>

          {/* Stars */}
          <section className='absolute left-1/2 transform -translate-x-1/2 right-6 top-2 z-50 lg:hidden'>
            <div className='grid justify-center pt-3 text-white text-3xl'>
              {'★★★★★'}
            </div>
          </section>
          <section className='absolute transform right-5 top-2 z-50 hidden lg:grid'>
            <div className='grid items-end pt-3 text-white text-4xl'>
              {'★★★★★'}
            </div>
            <div className='text-center'>
              <span><strong className='text-colour1'>Google Reviews</strong></span>
            </div>
          </section>
          {/* Section 2 */}
          <section className='absolute z-30 top-1/2 -mt-8 left-1/2 transform -translate-x-1/2 -translate-y-1/2'>
            {/* Header article */}
            <article
              className='grid text-colour1 text-center rounded-xl p-1.5 bg-colour6 fade-effect transition-opacity duration-[5000ms]'
              style={{ opacity: 0.7 }}
            >
              <div className='border-2 border-solid border-white rounded-lg py-2 lg:py-8 px-8'>
                <section className='grid h-fit'>
                  <div className='grid -mr-4 lg:pb-2'>
                    <img
                      src={MainLogoImage}
                      alt={`${CompanyName} business logo - Colour2 Logo`}
                      className='min-w-10 max-w-24 lg:max-w-40 xl:max-w-48 h-auto cursor-pointer active:scale-95 mx-auto'
                    />
                  </div>
                  <div>
                    <h1 className='text-xl lg:text-3xl font-semibold leading-6'>
                      {CompanyName}
                    </h1>
                  </div>
                  <div className='grid w-full text-sm mt-2 leading-4 lg:text-xl max-w-[24ch] mx-auto'>
                    <h2>{CompanyTagLine}</h2>
                  </div>
                  <div className='grid mt-2 mx-auto lg:text-2xl'>
                    <a
                      href={`tel:${CompanyPhoneNumber}`}
                      className='grid grid-flow-col w-min  justify-center gap-1'
                    >
                      <span className='font-medium'>Call:</span>{' '}
                      {CompanyPhoneNumber}
                    </a>
                  </div>
                </section>
              </div>
            </article>
          </section>
        </section>
      </div>
    </header>
  );
}

export default HomePageHeader;
